import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useRef } from 'react';
import { g as getTranslationComponent } from '../../i18n/FileDownloadButtonTranslation/index-CdrbKyuw.js';
import { d as downloadFileFromHref } from './downloadFileFromHref-kavfT3WV.js';
import { l as logWithTakt } from './logWithTakt-BL7gp6Oa.js';
import { T as TriggerButton } from './TriggerButton-DK-Z7ds2.js';
import { W as WarningModal } from './WarningModal-wepxJ6AZ.js';
import { T as TaktWrapper } from './TaktWrapper-D0n9LpMr.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as IntlProvider } from '../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DUNZ897o-Dn-1_05J.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { v as v4 } from '../../3rdPartyModules/uuid/dist/esm-browser/v4-CYEyAeRz.js';

const FileDownloadButton = ({
  internalWarningVisible,
  onDownload,
  onDownloadSuccess,
  onDownloadError,
  href,
  fileMetadata,
  fileName,
  onClick,
  label,
  hideLabel,
  icon,
  taktId,
  taktValue,
  locale,
  ...restProps
}) => {
  var _ref, _restProps$dataTakt, _window;
  const taktFallbackId = createStormTaktId('file-download-button');
  const internalTaktId = (_ref = (_restProps$dataTakt = restProps['data-takt-id']) !== null && _restProps$dataTakt !== void 0 ? _restProps$dataTakt : taktId) !== null && _ref !== void 0 ? _ref : taktFallbackId;
  const translations = getTranslationComponent(locale);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const buttonRef = useRef();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  // eslint-disable-next-line no-underscore-dangle
  const accessType = (_window = window) === null || _window === void 0 || (_window = _window.__AACChrome__) === null || _window === void 0 || (_window = _window.context) === null || _window === void 0 ? void 0 : _window.accessType;
  const isInternalUser = internalWarningVisible !== null && internalWarningVisible !== void 0 ? internalWarningVisible : accessType === 'Impersonator';
  const handleClick = async event => {
    const uuid = v4();
    const taktDetails = {
      fileName,
      uuid,
      ...(fileMetadata || {})
    };
    try {
      onClick === null || onClick === void 0 || onClick(event);
      if (href) {
        downloadFileFromHref(fileName, href, `${internalTaktId}-temporary-a`);
      }
      logWithTakt('storm_ui_file_download_button_download_initial', taktDetails);
      await onDownload(uuid);
      logWithTakt('storm_ui_file_download_button_download_success', taktDetails);
      onDownloadSuccess === null || onDownloadSuccess === void 0 || onDownloadSuccess(uuid);
    } catch (error) {
      logWithTakt('storm_ui_file_download_button_download_error', taktDetails);
      onDownloadError === null || onDownloadError === void 0 || onDownloadError(uuid, error instanceof Error ? error : new Error('storm_ui_file_download_button_download_error'));
    }
  };
  return /*#__PURE__*/React__default.createElement(TaktWrapper, {
    taktId: internalTaktId
  }, isInternalUser ? /*#__PURE__*/React__default.createElement(IntlProvider, {
    resetKey: locale,
    translations: translations
  }, /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: internalTaktId,
    taktValue: taktValue
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TriggerButton, _extends({}, restProps, getDataTaktAttributes({
    taktIdSuffix: 'internal-warning-trigger-button'
  }), {
    buttonRef: buttonRef,
    hideLabel: hideLabel,
    icon: icon,
    label: label,
    onClick: () => {
      setIsModalOpen(true);
    }
  })), /*#__PURE__*/React__default.createElement(WarningModal, {
    cancelButtonProps: {
      ...getDataTaktAttributes({
        taktIdSuffix: 'internal-warning-cancel-button'
      })
    },
    confirmButtonProps: {
      ...restProps,
      ...getDataTaktAttributes({
        taktIdSuffix: 'internal-warning-confirm-button'
      })
    },
    isOpen: isModalOpen,
    label: label,
    onCancel: () => {
      setIsModalOpen(false);
    },
    onConfirm: event => {
      setIsModalOpen(false);
      handleClick(event);
    },
    toggleEl: buttonRef.current
  })))) : /*#__PURE__*/React__default.createElement(TriggerButton, _extends({}, restProps, {
    taktId: taktId,
    taktValue: taktValue,
    taktFallbackId: taktFallbackId,
    hideLabel: hideLabel,
    icon: icon,
    label: label,
    onClick: handleClick
  })));
};

export { FileDownloadButton as F };
//# sourceMappingURL=FileDownloadButton-DB-fOmrW.js.map
